<template>
    <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-100">
            <thead class="bg-gray-50">
                <tr>
                    <SortableTh :label="t('vue.id')" field="id" />
                    <SortableTh :label="t('vue.team')" field="name" />
                    <SortableTh
                        :label="t('vue.kiosk_da_owner_email')"
                        field="owner_email"
                    />
                    <SortableTh
                        v-if="activeTabDef?.showPlan"
                        :label="t('vue.plan')"
                        field="subscription_level"
                    />
                    <SortableTh :label="t('vue.kiosk_da_time')" field="time" />
                    <th
                        class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500"
                    />
                </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
                <tr
                    v-for="item in items"
                    :key="item.id"
                    class="hover:bg-gray-50/60"
                >
                    <td class="px-4 py-3 font-mono text-xs text-gray-400">
                        {{ item.id }}
                    </td>
                    <td class="px-4 py-3 text-sm font-medium text-gray-900">
                        <div class="flex items-center gap-2">
                            <div
                                class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full"
                                :class="activeTabDef?.bgColor ?? 'bg-gray-200'"
                            >
                                <component
                                    :is="activeTabDef?.icon ?? UserGroupIcon"
                                    class="h-3.5 w-3.5 text-white"
                                />
                            </div>
                            {{ item.name }}
                        </div>
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        {{ item.owner_email ?? "—" }}
                    </td>
                    <td
                        v-if="activeTabDef?.showPlan"
                        class="px-4 py-3 text-sm text-gray-600"
                    >
                        <span
                            class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium"
                            :class="getPlanBadgeClass(item.subscription_level)"
                        >
                            <component
                                :is="getPlanIcon(item.subscription_level)"
                                class="h-3 w-3"
                            />
                            {{ item.subscription_level ?? "trial" }}
                        </span>
                    </td>
                    <td class="px-4 py-3 text-sm text-gray-600">
                        {{ item.time ?? "—" }}
                    </td>
                    <td class="px-4 py-3 text-right text-sm text-gray-600">
                        <AdminLink :href="item.kiosk_url" />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script lang="ts" setup>
import { UserGroupIcon } from "@heroicons/vue/24/outline";
import { useTranslations } from "@/composables/useTranslations";
import {
    getPlanBadgeClass,
    getPlanIcon,
} from "../../composables/useActivityTabs";
import type { ITabDef, ITeamItem } from "../../types";

const { t } = useTranslations();

defineProps<{
    items: ITeamItem[];
    activeTabDef: ITabDef | null;
}>();
</script>
